export const APP_DATA_SOURCE_LOCAL_STORAGE_KEY = "SELECTED_APP_DATA_SOURCE";
